import React, { useEffect, useState } from "react";
import { navigate } from "gatsby";

import MENU_PATHS from "../../../../constants/menu";
import ICONS from "../../../../constants/icons";

import { IconButton } from "../../../buttons";
import Button from "../../../buttons/Button";
import MenuItems from "../menuItems";

const handleSignUp = () => {
  window.open("https://app.skillndepth.com/", "_blank");
};

const Navbar = ({ homePage }: { homePage?: boolean }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    setIsVisible(window.scrollY > 200);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const renderVisibleClass = isVisible ? "-visible" : "";

  return (
    <div
      className={`m-navbar aligned-center
        ${homePage ? renderVisibleClass : "-visible"}`}
    >
      <div className="_wr">
        <div className="_w">
          <div className="_12 space-between fullWidth aligned-center">
            <IconButton
              handleClick={() => navigate(MENU_PATHS.HOMEPAGE)}
              name={ICONS.LOGO}
              aria={{
                label: "Logo image",
              }}
            />

            <div className="aligned-center -gap100">
              <div className="m-navbar__menuItems row">
                <MenuItems />
              </div>

              <Button
                name="Sign in"
                handleClick={handleSignUp}
                buttonClass="ternary"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
